
import React from "react";
import { FaPlus } from "react-icons/fa";
import useScrollReveal from "../../Hooks/useScrollReveal";
import "./InsightImageLeft.css";

function InsightImageLeft({title = "Innovación", image, imageAlt = "", description, category = "FEATURED ARTICLE", articleTitle, readMoreUrl = "#",}) {
    const { elementRef, isVisible } = useScrollReveal();

    return (
        <section
            ref={elementRef}
            className={`insight-left ${
                isVisible ? "is-visible" : ""
            }`}
        >
            <div className="insight-left__image">
                <img src={image} alt={imageAlt} loading="lazy" />
            </div>

            <div className="insight-left__heading">
                <h2>{title}</h2>
            </div>

            <article className="insight-left__featured">
        <span className="insight-left__category">
          {category}
        </span>

                <div className="insight-left__featured-content">
                    <h3>{articleTitle}</h3>

                    <a
                        href={readMoreUrl}
                        target="_blank"
                        className="insight-left__read-more"
                        aria-label={`Leer más: ${articleTitle}`}
                        rel="noreferrer"
                    >
                        <span>Leer más</span>
                        <FaPlus aria-hidden="true" />
                    </a>
                </div>
            </article>

            <div className="insight-left__description">
                <p>{description}</p>
            </div>
        </section>
    );
}

export default InsightImageLeft;
